import { IFilterOption } from "../../../components/Table/Utils/Interfaces/IFilter";

const queryFilters = (filters: IFilterOption[]) => {
  const statusFilters = filters.filter((filter) => filter.column === "STATUS");
  const statusParams = statusFilters
    .map((filter) => `${filter.column}=${filter.name}`)
    .join("&");

  const otherFilters = filters.filter((filter) => filter.column !== "STATUS");
  const otherParams = otherFilters
    .map((filter) => `${filter.name}=${filter.value}`)
    .join("&");

  const queryParams = [statusParams, otherParams].filter(Boolean).join("&");

  // const response = await api.get(`/filters?${queryParams}`);
  return queryParams;
};
export default queryFilters;
